<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <!-- Overlapping icon -->
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-badge-check text-white text-4xl"></i>
      </div>
    </div>
    <!-- Card content -->
    <div class="px-6">
      <h2 class="text-2xl font-bold text-center mb-1">Verifica il tuo numero</h2>
      <p class="text-gray-500 text-center mb-4">Sarà sufficiente indicare il numero di telefono</p>
      <CuPhoneInput
        v-model="phone"
        label="Telefono"
        placeholder="+39 345 123 4567"
        :loading="false"
        :disabled="false"
      />
      <div v-if="error" class="text-red-500 text-sm mt-2 text-center">
        {{ error }}
      </div>
      <div class="flex gap-3 mt-6">
        <CuButton dark class="flex-1" @click="$emit('close')">Annulla</CuButton>
        <CuButton primary class="flex-1" @click="confirm">Conferma</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'
import CuPhoneInput from '../cu/CuPhoneInput.vue'

export default {
  name: "PhoneNumberSheet",
  components: { BottomSheet, CuButton, CuPhoneInput },
  props: {
    show: { type: Boolean, default: false },
    error: { type: String, default: null }
  },
  data() {
    return {
      phone: ''
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm', this.phone)
    }
  }
}
</script>
